import React from 'react';

import Theme from 'Theme';
import Form from 'components/Form';
import Button from 'components/Button';

import {
  Link,
  DetailsContain,
  FadeInContainer,
  ErrorNotice,
  ButtonContain
} from './Styled';

export const RegisterAccount = ({ 
  onPrev,
  values,
  onSubmit,
  invitation,
  errors = [],
  onCreateAccount,
  invitationError
}) => {
  return (
    <FadeInContainer>
      <DetailsContain>
        {
          !!invitation && !invitationError &&
          <div style={{ marginBottom: '1em' }}>
            <Link href={'#'} onClick={onCreateAccount}>View Account Invitation</Link>
          </div>
        }

        {
          invitationError &&
          <ErrorNotice>
            We had trouble accessing the account invitation details. The invitation may have expired or been removed. 
            please contact the inviting conveyancer or continue by registering a new account.
          </ErrorNotice>
        }

        <Form.Fields
          values={values}
          errors={errors}
          transition="slide"
          renderSubmit={(submitForm) => (
            <ButtonContain>
              <Form.Submit
                label={'Submit'}
                color={Theme.brandColor}
                onSubmit={() => onSubmit(submitForm())}
              />
            </ButtonContain>
          )}
        >
          <Form.TextInput
            required
            name="name"
            label={'Business Name'}
            placeholder={'Enter the business name'}
          />
          <Form.TextInput
            required
            name="address_line1"
            label={'Address Line 1'}
            placeholder={'Enter address line 1'}
          />
          <Form.TextInput
            label={'Address Line 2'}
            name="address_line2"
            placeholder={'Enter address line 2'}
          />
          <Form.TextInput
            required
            type={'address_suburb'}
            label={'Suburb'}
            name="address_suburb"
            placeholder={'Enter address suburb'}
          />
          <Form.TextInput
            required
            label={'State'}
            name="address_state"
            placeholder={'Enter address state'}
          />
          <Form.TextInput
            required
            label={'Postcode'}
            name="address_postcode"
            placeholder={'Enter postcode'}
          />
        </Form.Fields>
        <Button.Default
          border
          secondary
          label={'Back'}
          onClick={onPrev}
          color={Theme.brandColor}
        />
      </DetailsContain>
    </FadeInContainer>
  );
};

export default RegisterAccount;
